import { render, staticRenderFns } from "./EquipmentDetails.vue?vue&type=template&id=2baa890f&scoped=true"
import script from "./EquipmentDetails.vue?vue&type=script&lang=js"
export * from "./EquipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./EquipmentDetails.vue?vue&type=style&index=0&id=2baa890f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa890f",
  null
  
)

export default component.exports